module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "100%",
      "overflow-y": "auto"
    }
  }, [_c('v-toolbar', {
    staticClass: "primary",
    attrs: {
      "dark": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$router.push('/home')
      }
    }
  }, [_c('v-icon', [_vm._v("chevron_left")])], 1), _vm._v(" "), _c('v-toolbar-title', [_vm._v(_vm._s(_vm.lender) + " Documents\n\n        "), _c('v-menu', {
    attrs: {
      "offset-y": "",
      "nudge-bottom": 7,
      "left": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": ""
          }
        }, on), [_c('v-icon', [_vm._v("keyboard_arrow_down")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('v-list', [_vm._l((_vm.lenders), function(lender) {
    return _c('v-list-item', {
      key: lender.name,
      on: {
        "click": function($event) {
          return _vm.setLender(lender.name)
        }
      }
    }, [_c('v-list-item-title', [_vm._v(_vm._s(lender.name))])], 1)
  }), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list-item', {
    key: "general",
    on: {
      "click": function($event) {
        return _vm.setLender('General')
      }
    }
  }, [_c('v-list-item-title', [_vm._v("General Options")])], 1)], 2)], 1)], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    }
  }, [_c('v-icon', [_vm._v("more_vert")])], 1)], 1), _vm._v(" "), _vm._l((_vm.categories), function(category) {
    return _c('div', {
      key: category['.key'],
      staticClass: "pa-3"
    }, [_c('h4', [_vm._v(_vm._s(category.name) + "\n        "), _c('v-menu', {
      attrs: {
        "offset-y": "",
        "left": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function(ref) {
          var on = ref.on;

          return [_c('v-btn', _vm._g({
            staticClass: "blue--text",
            attrs: {
              "icon": ""
            }
          }, on), [_c('v-icon', [_vm._v("keyboard_arrow_down")])], 1)]
        }
      }], null, true)
    }, [_vm._v(" "), _c('v-list', [_c('v-list-item', {
      on: {
        "click": function($event) {
          return _vm.showDocumentDialog(null, category)
        }
      }
    }, [_c('v-list-item-title', [_vm._v("Add " + _vm._s(category.name) + " Heading")])], 1)], 1)], 1)], 1), _vm._v(" "), _vm._l((_vm.requirementsForCategory(category.name)), function(requirement) {
      return _c('div', {
        key: requirement['.key']
      }, [_c('v-toolbar', {
        staticClass: "primary",
        attrs: {
          "dark": ""
        },
        nativeOn: {
          "dblclick": function($event) {
            $event.stopPropagation();
            return _vm.showDocumentDialog(requirement, null)
          }
        }
      }, [_c('v-toolbar-title', {
        staticStyle: {
          "user-select": "none"
        }
      }, [_vm._v(_vm._s(requirement.name))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
        attrs: {
          "icon": ""
        },
        nativeOn: {
          "click": function($event) {
            $event.stopPropagation();
            return _vm.showRequirementDialog(null, requirement)
          }
        }
      }, [_c('v-icon', [_vm._v("add_circle")])], 1)], 1), _vm._v(" "), (_vm.lender != 'General') ? [_c('v-expansion-panel', _vm._l((_vm.requestsForRequirement(requirement['.key'])), function(request) {
        return _c('v-expansion-panel-content', {
          key: request['.key'],
          staticClass: "blue lighten-3"
        }, [_c('div', {
          attrs: {
            "slot": "header"
          },
          slot: "header"
        }, [_vm._v(_vm._s(request.name))]), _vm._v(" "), _c('v-card', [_c('v-card-text', {
          staticClass: "grey lighten-3",
          staticStyle: {
            "min-height": "100px"
          }
        }, [_c('v-btn', {
          staticClass: "grey--text",
          staticStyle: {
            "float": "right"
          },
          attrs: {
            "outlined": ""
          },
          nativeOn: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.showRequirementDialog(request, null)
            }
          }
        }, [_vm._v("Edit")]), _vm._v(" "), _c('v-row', {
          attrs: {
            "wrap": ""
          }
        }, [_c('v-col', {
          attrs: {
            "xs12": "",
            "sm4": ""
          }
        }, [_c('b', [_vm._v("Description")]), _c('br'), _vm._v("\n                            " + _vm._s(request.description)), _c('br'), _c('br')]), _vm._v(" "), _c('v-col', {
          attrs: {
            "xs12": "",
            "sm4": ""
          }
        }, [_c('b', [_vm._v("Instructions")]), _c('br'), _vm._v(" "), _c('span', {
          domProps: {
            "innerHTML": _vm._s((request.instructions))
          }
        }), _c('br'), _c('br')]), _vm._v(" "), _c('v-col', {
          attrs: {
            "xs12": "",
            "sm4": ""
          }
        }, [_c('b', [_vm._v("Things to Check")]), _c('br'), _vm._v(" "), _c('ul', _vm._l((request.checklist), function(check) {
          return _c('li', {
            key: check['key']
          }, [_vm._v("\n                                " + _vm._s(check.text) + "\n                                ")])
        }), 0), _vm._v(" "), _c('br')])], 1)], 1)], 1)], 1)
      }), 1)] : _vm._e(), _vm._v(" "), _c('v-expansion-panel', _vm._l((_vm.generalRequestsForRequirement(requirement['.key'])), function(request, i) {
        return _c('v-expansion-panel-content', {
          key: i
        }, [_c('div', {
          attrs: {
            "slot": "header"
          },
          slot: "header"
        }, [_vm._v(_vm._s(request.name))]), _vm._v(" "), _c('v-card', [_c('v-card-text', {
          staticClass: "grey lighten-3",
          staticStyle: {
            "min-height": "100px"
          }
        }, [(_vm.lender == 'General') ? _c('v-btn', {
          staticClass: "grey--text",
          staticStyle: {
            "float": "right"
          },
          attrs: {
            "outlined": ""
          },
          nativeOn: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.showRequirementDialog(request, null)
            }
          }
        }, [_vm._v("Edit")]) : _c('v-btn', {
          staticClass: "grey--text",
          staticStyle: {
            "float": "right"
          },
          attrs: {
            "outlined": ""
          },
          nativeOn: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.copyToLender(request)
            }
          }
        }, [_vm._v("Copy to " + _vm._s(_vm.lender))]), _vm._v(" "), _c('v-row', {
          attrs: {
            "wrap": ""
          }
        }, [_c('v-col', {
          attrs: {
            "xs12": "",
            "sm4": ""
          }
        }, [_c('b', [_vm._v("Description")]), _c('br'), _vm._v("\n                            " + _vm._s(request.description)), _c('br'), _c('br'), _vm._v(" "), _c('b', [_vm._v("Download Link")]), _c('br'), _vm._v(" "), _c('a', {
          attrs: {
            "target": "_blank",
            "href": request.download
          }
        }, [_vm._v(_vm._s(request.download))]), _c('br'), _c('br')]), _vm._v(" "), _c('v-col', {
          attrs: {
            "xs12": "",
            "sm4": ""
          }
        }, [_c('b', [_vm._v("Instructions")]), _c('br'), _vm._v(" "), _c('span', {
          domProps: {
            "innerHTML": _vm._s((request.instructions))
          }
        }), _c('br'), _c('br')]), _vm._v(" "), _c('v-col', {
          attrs: {
            "xs12": "",
            "sm4": ""
          }
        }, [_c('b', [_vm._v("Things to Check")]), _c('br'), _vm._v(" "), _c('ul', _vm._l((request.checklist), function(check) {
          return _c('li', {
            key: check.key
          }, [_vm._v("\n                                " + _vm._s(check.text) + "\n                                ")])
        }), 0), _vm._v(" "), _c('br')])], 1)], 1)], 1)], 1)
      }), 1), _vm._v(" "), _c('br')], 2)
    })], 2)
  }), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "fullscreen": _vm.$vuetify.breakpoint.xsOnly,
      "transition": "v-fade-transition",
      "hide-overlay": true,
      "persistent": ""
    },
    model: {
      value: (_vm.documentDialog.visible),
      callback: function($$v) {
        _vm.$set(_vm.documentDialog, "visible", $$v)
      },
      expression: "documentDialog.visible"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('h3', {
    staticClass: "mb-0 grey--text text--darken-2"
  }, [_vm._v(_vm._s(_vm.documentDialog.model.category.name) + " Document")])]), _vm._v(" "), _c('v-card-text', [_c('v-text-field', {
    attrs: {
      "name": "document-name",
      "label": "Document Name",
      "id": "document-name"
    },
    model: {
      value: (_vm.documentDialog.model.name),
      callback: function($$v) {
        _vm.$set(_vm.documentDialog.model, "name", $$v)
      },
      expression: "documentDialog.model.name"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "grey--text"
  }, [_vm._v("Importance")]), _vm._v(" "), _c('v-slider', {
    attrs: {
      "min": "0",
      "max": "10",
      "step": "1"
    },
    model: {
      value: (_vm.documentDialog.model.importance),
      callback: function($$v) {
        _vm.$set(_vm.documentDialog.model, "importance", $$v)
      },
      expression: "documentDialog.model.importance"
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "text": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.documentDialogSave($event)
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.documentDialogCancel($event)
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "500",
      "fullscreen": _vm.$vuetify.breakpoint.xsOnly,
      "transition": "v-fade-transition",
      "hide-overlay": false,
      "scrollable": ""
    },
    model: {
      value: (_vm.requirementDialog.visible),
      callback: function($$v) {
        _vm.$set(_vm.requirementDialog, "visible", $$v)
      },
      expression: "requirementDialog.visible"
    }
  }, [_c('div', {
    staticClass: "dialog-container",
    style: ({
      height: _vm.dialogHeight
    })
  }, [_c('div', {
    staticClass: "dialog-header"
  }), _vm._v(" "), _c('div', {
    staticClass: "dialog-body"
  }, [_c('v-tabs', {
    attrs: {
      "color": "primary",
      "id": "mobile-tabs-1",
      "grow": "",
      "scroll-bars": "",
      "dark": ""
    },
    model: {
      value: (_vm.dialogTab),
      callback: function($$v) {
        _vm.dialogTab = $$v
      },
      expression: "dialogTab"
    }
  }, [_c('v-tab', {
    key: 1
  }, [_vm._v("\n                " + _vm._s(_vm.requirementDialog.model.requirementName) + "\n            ")]), _vm._v(" "), _c('v-tab', {
    key: 2
  }, [_vm._v("\n                Instructions\n            ")]), _vm._v(" "), _c('v-tab', {
    key: 3
  }, [_vm._v("\n                Checklist\n            ")]), _vm._v(" "), _c('v-tab-item', {
    key: 1,
    staticClass: "pa-3"
  }, [_c('v-text-field', {
    attrs: {
      "name": "document-name",
      "label": "Document Name"
    },
    model: {
      value: (_vm.requirementDialog.model.name),
      callback: function($$v) {
        _vm.$set(_vm.requirementDialog.model, "name", $$v)
      },
      expression: "requirementDialog.model.name"
    }
  }), _vm._v(" "), _c('v-textarea', {
    attrs: {
      "rows": "3",
      "name": "document-description",
      "label": "Description"
    },
    model: {
      value: (_vm.requirementDialog.model.description),
      callback: function($$v) {
        _vm.$set(_vm.requirementDialog.model, "description", $$v)
      },
      expression: "requirementDialog.model.description"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "name": "document-download",
      "label": "Download Link"
    },
    model: {
      value: (_vm.requirementDialog.model.download),
      callback: function($$v) {
        _vm.$set(_vm.requirementDialog.model, "download", $$v)
      },
      expression: "requirementDialog.model.download"
    }
  }), _vm._v(" "), _c('table', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('tr', [_c('td', [_c('v-text-field', {
    attrs: {
      "name": "document-expiry-days",
      "label": "Expiry Days"
    },
    model: {
      value: (_vm.requirementDialog.model.expiryDays),
      callback: function($$v) {
        _vm.$set(_vm.requirementDialog.model, "expiryDays", $$v)
      },
      expression: "requirementDialog.model.expiryDays"
    }
  })], 1), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "150px"
    }
  }, [_c('v-checkbox', {
    staticStyle: {
      "margin-top": "0px"
    },
    attrs: {
      "hide-details": "",
      "label": "Not Required",
      "color": "primary"
    },
    model: {
      value: (_vm.requirementDialog.model.notRequired),
      callback: function($$v) {
        _vm.$set(_vm.requirementDialog.model, "notRequired", $$v)
      },
      expression: "requirementDialog.model.notRequired"
    }
  })], 1)])]), _vm._v(" "), _c('v-slider', {
    attrs: {
      "label": "Importance",
      "min": "0",
      "max": "10",
      "step": "1"
    },
    model: {
      value: (_vm.requirementDialog.model.importance),
      callback: function($$v) {
        _vm.$set(_vm.requirementDialog.model, "importance", $$v)
      },
      expression: "requirementDialog.model.importance"
    }
  })], 1), _vm._v(" "), _c('v-tab-item', {
    key: 2,
    staticClass: "pa-3"
  }, [_c('v-textarea', {
    attrs: {
      "rows": "8",
      "name": "document-description",
      "label": "Instructions"
    },
    model: {
      value: (_vm.requirementDialog.model.instructions),
      callback: function($$v) {
        _vm.$set(_vm.requirementDialog.model, "instructions", $$v)
      },
      expression: "requirementDialog.model.instructions"
    }
  })], 1), _vm._v(" "), _c('v-tab-item', {
    key: 3,
    staticClass: "pa-3"
  }, [_vm._l((_vm.requirementDialog.model.checklist), function(check, index) {
    return _c('div', {
      key: check['.key']
    }, [_c('DeleteButton', {
      staticStyle: {
        "float": "right"
      },
      on: {
        "click": function($event) {
          return _vm.requirementsDialog.model.checklist.splice(index, 1)
        }
      }
    }), _vm._v(" "), _c('v-text-field', {
      staticStyle: {
        "width": "85%"
      },
      model: {
        value: (check.text),
        callback: function($$v) {
          _vm.$set(check, "text", $$v)
        },
        expression: "check.text"
      }
    })], 1)
  }), _vm._v(" "), _c('div', [_c('v-text-field', {
    attrs: {
      "label": "Add Check Item"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.addCheckItem($event)
      }
    },
    model: {
      value: (_vm.newCheckItem),
      callback: function($$v) {
        _vm.newCheckItem = $$v
      },
      expression: "newCheckItem"
    }
  })], 1)], 2)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer"
  }, [(_vm.requirementDialog.model['.key']) ? _c('DeleteButton', {
    staticStyle: {
      "float": "left"
    },
    on: {
      "delete": function($event) {
        return _vm.deleteRequirement(_vm.requirementDialog.model['.key'])
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.requirementDialogSave($event)
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.requirementDialogCancel($event)
      }
    }
  }, [_vm._v("Cancel")])], 1)])])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0509837c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/SupplierChecklist/SupplierDocuments.vue
// module id = 2431
// module chunks = 1